/**
 * copyText (utils/clipboard.ts) plus the toast every Copy button wants: success
 * when it copied, an error when neither the Clipboard API nor the legacy path
 * worked. Returns whether the copy happened so a caller can flip its "copied" tick.
 */
import { copyText } from '@/utils/clipboard'
import { toast } from '@/lib/toast'

export async function copyWithToast(
  text: string,
  opts: { success?: string | false; error?: string } = {},
): Promise<boolean> {
  const ok = await copyText(text)
  if (ok) {
    if (opts.success !== false) toast.success(opts.success ?? 'Copied to clipboard')
  } else {
    toast.error(opts.error ?? 'Could not copy to the clipboard. Select the text and copy it manually.')
  }
  return ok
}
